export default "__VITE_ASSET__CmIbG$Fk__"